<template>
  <StepLayout
    :title="`${keyword}に関して医療機関を受診していますか？`"
    :current-step="3"
    @back="handleBack"
  >
    <OptionList
      v-model="model"
      :options="medicalVisitOptions"
      aria-label="受診状況の選択"
      @select="handleSelect"
    />

    <template #footer>
      <SkipLink label="この質問をスキップする" @click="handleSkip" />
    </template>
  </StepLayout>
</template>

<script setup lang="ts">
import StepLayout from './StepLayout.vue';
import OptionList from './OptionList.vue';
import SkipLink from './SkipLink.vue';
import type { MedicalVisitOption } from '../types';

defineProps<{
  keyword: string;
}>();

const model = defineModel<MedicalVisitOption | null>({ default: null });

const emit = defineEmits<{
  next: [];
  back: [];
  skip: [];
}>();

const medicalVisitOptions = [
  { value: 'before', label: '受診前', subtitle: 'これから行く・検討中' },
  { value: 'during', label: '通院中', subtitle: '現在治療のため通院している' },
  { value: 'after', label: '受診後', subtitle: '治った・もう行っていない' },
];

const handleSelect = () => {
  emit('next');
};

const handleBack = () => {
  emit('back');
};

const handleSkip = () => {
  emit('skip');
};
</script>

<style lang="scss" scoped>
// StepLayout provides all common styling
</style>
